import VipMedallion from "@/components/vip/VipMedallion";

// Owner-granted PERMANENT Boss/Crown badge. Independent of the monthly VIP tiers — never resets.
export default function LifetimeBossBadge({ show, size = "sm", className = "" }) {
  if (!show) return null;
  const dim = size === "xs" ? "text-[9px] px-1 py-px gap-1" : "text-[10px] px-1.5 py-0.5 gap-1.5";
  return (
    <span
      data-testid="lifetime-boss-badge"
      title="Boss · Lifetime — permanent owner badge"
      className={`inline-flex items-center border uppercase tracking-widest font-semibold ${dim} text-amber-200 border-amber-300/70 bg-gradient-to-r from-amber-500/25 via-rose-600/20 to-amber-500/25 shadow-[0_0_10px_rgba(251,191,36,0.35)] ${className}`}
    >
      <VipMedallion tier="boss" src="/vip-art/lifetime_boss.png" size="xs" className={size === "xs" ? "!w-3.5 !h-3.5" : "!w-4 !h-4"} /> Boss · Lifetime
    </span>
  );
}
